query icons {
  icons {
    id
    name
    displayName
  }
}
